import { render, staticRenderFns } from "./tizhi.vue?vue&type=template&id=3f35b8b8&scoped=true"
import script from "./tizhi.vue?vue&type=script&lang=js"
export * from "./tizhi.vue?vue&type=script&lang=js"
import style0 from "./tizhi.vue?vue&type=style&index=0&id=3f35b8b8&lang=scss&scoped=true"
import style1 from "./tizhi.vue?vue&type=style&index=1&id=3f35b8b8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f35b8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f35b8b8')) {
      api.createRecord('3f35b8b8', component.options)
    } else {
      api.reload('3f35b8b8', component.options)
    }
    module.hot.accept("./tizhi.vue?vue&type=template&id=3f35b8b8&scoped=true", function () {
      api.rerender('3f35b8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/tizhi.vue"
export default component.exports